//请自行添加语言资源
const addr = {
  addrCode: '地址编码',
  addrName: '地址名称',
  region: '区域',
  addrType: '地址类型',
  shipperName: '所属客户',
  companyName: '所属机构',
  useCompanyName: '使用机构',
  provinceCode: '省份编号',
  provinceName: '省',
  cityCode: '市编号',
  cityName: '市',
  districtCode: '区编号',
  districtName: '区',
  addr: '详细地址',
  lat: '纬度',
  lng: '经度',
  contactMan: '联系人',
  contactWay: '联系方式',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '修改时间',
  updater: '修改者',
  msg: {
    addrType: '请选择地址类型',
    addrCode: '请输入地址编码',
    addrName: '请输入地址名称',
    region: '请选择区域',
    shipperCode: '请选择所属客户',
    companyCode: '请选择所属机构',
    addr: '请输入详细地址',
  }
};
export default addr



// WEBPACK FOOTER //
// ./src/page/mdm/addr/lang/addr.zh.js